<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('discount Rates')"
          :description="$t('from Here You Can Control The Units Of The Discount Rates')"
        />
        <indexTable
          :searchText="$t('Search For A Discount Rate')"
          :emptyTableText="$t('there Are No Discount Rates')"
          :localData="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="true"
          :cloumns="[
            {
              column: 'name',
              title: $t('Name The discount rate'),
              type: 'text',
              sort: true
            },
            {
              column: 'rate',
              title: $t('Discount rate'),
              type: 'text',
              sort: true,
              after: '%'
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: true },
                { name: 'delete', role: true }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/discounts'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
